/* La Banda del Riccio — navigazione gallery */

(function () {
  /* Patch product-info: ripristina il pulsante quando i blocchi non renderizzano nel section fetch */
  customElements.whenDefined('product-info').then(function () {
    var proto = Object.getPrototypeOf(document.createElement('product-info'));
    var origMethod = proto.handleUpdateProductInfo;
    if (!origMethod) return;

    proto.handleUpdateProductInfo = function (productUrl) {
      var origCallback = origMethod.call(this, productUrl);
      var self = this;
      return function (html) {
        if (!html.querySelector('variant-selects')) {
          var sectionId = self.dataset.originalSection || self.dataset.section;
          var fallback  = html.getElementById('BdrSelectedVariant-' + sectionId);
          if (fallback) {
            try {
              var variant = JSON.parse(fallback.textContent);
              var isAvailable = !!(variant && variant.available);
              if (self.productForm) {
                self.productForm.toggleSubmitButton(
                  !isAvailable,
                  isAvailable ? '' : (window.variantStrings && window.variantStrings.soldOut)
                );
              }
            } catch (err) {}
          }
          return;
        }
        origCallback.call(self, html);
      };
    };
  });

  customElements.whenDefined('media-gallery').then(function () {
    document.querySelectorAll('media-gallery').forEach(function (gallery) {
      var viewer = gallery.querySelector('[id^="GalleryViewer"]');
      if (!viewer) return;

      function navigate(dir) {
        var items   = Array.from(viewer.querySelectorAll('[data-media-id]'));
        var current = items.findIndex(function (el) { return el.classList.contains('is-active'); });
        if (current < 0) current = 0;
        var target  = dir === 'next' ? items[current + 1] : items[current - 1];
        if (!target) return;
        /* Rimuove classi animazione che nasconderebbero l'immagine al primo click */
        target.classList.remove('scroll-trigger', 'animate--fade-in', 'animate--slide-in');
        gallery.setActiveMedia(target.dataset.mediaId, false);
      }

      var prev = viewer.querySelector('.slider-button--prev');
      var next = viewer.querySelector('.slider-button--next');
      if (prev) prev.addEventListener('click', function () { navigate('prev'); });
      if (next) next.addEventListener('click', function () { navigate('next'); });
    });
  });
})();

/* Sticky bar */
(function () {
  var bar = document.querySelector('.bdr-sticky-bar');
  if (!bar) return;

  var sectionId  = bar.dataset.section;
  var mainBtn    = document.getElementById('ProductSubmitButton-' + sectionId);
  var mainForm   = document.getElementById('product-form-' + sectionId);
  if (!mainBtn || !mainForm) return;

  var stickyBtn  = bar.querySelector('.bdr-sticky-bar__btn');
  var selects    = Array.from(bar.querySelectorAll('.bdr-sticky-bar__select'));
  var variants   = [];
  try { variants = JSON.parse(bar.querySelector('.bdr-sticky-bar__variants').textContent); } catch (e) {}

  function findVariant(options) {
    return variants.find(function (v) {
      return v.options.every(function (o, i) { return o === options[i]; });
    }) || null;
  }

  function applyVariant(variant) {
    var available = !!(variant && variant.available);
    stickyBtn.disabled = !available;
    var label = available
      ? (window.variantStrings ? window.variantStrings.addToCart : 'Aggiungi al carrello')
      : (window.variantStrings ? window.variantStrings.soldOut   : 'Esaurito');
    stickyBtn.textContent = label;
    if (variant) {
      var input = mainForm.querySelector('[name="id"]');
      if (input) input.value = variant.id;
    }
  }

  function onSelectChange() {
    var variant = selects.length === 0 ? (variants[0] || null) : findVariant(selects.map(function (s) { return s.value; }));
    applyVariant(variant);
  }

  selects.forEach(function (s) { s.addEventListener('change', onSelectChange); });

  /* Sync sticky selects quando cambia la variante nella pagina principale */
  var mainPicker = document.querySelector('variant-selects[data-section="' + sectionId + '"], variant-radios[data-section="' + sectionId + '"]');
  if (mainPicker) {
    mainPicker.addEventListener('change', function () {
      var mainInputs = Array.from(mainPicker.querySelectorAll('select, input[type="radio"]:checked'));
      mainInputs.forEach(function (el, i) {
        if (selects[i]) selects[i].value = el.value;
      });
      onSelectChange();
    });
  }

  /* Sync stato disabilitato dal pulsante principale (variante non disponibile) */
  new MutationObserver(function () {
    stickyBtn.disabled = mainBtn.disabled;
  }).observe(mainBtn, { attributes: true, attributeFilter: ['disabled'] });

  /* Mostra/nascondi dopo aver superato l'intera sezione prodotto */
  var productSection = document.getElementById('shopify-section-' + sectionId);
  new IntersectionObserver(function (entries) {
    var visible = entries[0].isIntersecting;
    bar.classList.toggle('is-visible', !visible);
    bar.setAttribute('aria-hidden', visible ? 'true' : 'false');
  }, { threshold: 0 }).observe(productSection || mainBtn);

  stickyBtn.addEventListener('click', function () { mainBtn.click(); });

  onSelectChange();
})();

/* Accordion — animazione fluida height */
(function () {
  function initAccordion(details) {
    var content = details.querySelector('.bdr-product__accordion-content');
    if (!content) return;

    var isAnimating = false;

    details.querySelector('summary').addEventListener('click', function (e) {
      e.preventDefault();
      if (isAnimating) return;
      isAnimating = true;

      if (details.open) {
        var startH = content.scrollHeight;
        content.style.height = startH + 'px';
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            content.style.height = '0px';
          });
        });
        content.addEventListener('transitionend', function done() {
          content.removeEventListener('transitionend', done);
          details.removeAttribute('open');
          content.style.height = '';
          isAnimating = false;
        });
      } else {
        details.setAttribute('open', '');
        var targetH = content.scrollHeight;
        content.style.height = '0px';
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            content.style.height = targetH + 'px';
          });
        });
        content.addEventListener('transitionend', function done() {
          content.removeEventListener('transitionend', done);
          content.style.height = '';
          isAnimating = false;
        });
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.bdr-product__accordion details').forEach(initAccordion);
  });
})();
